import { Injectable } from '@angular/core';
import {
  ExercicioService,
  FuncaoService, GlobalService, OrgaoService,
  Relatorio
} from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FichaDespesaService } from '../../../../planejamento/ficha-despesa/service/ficha-despesa.service';

@Injectable({
  providedIn: 'root'
})
export class BalanceteDespesaFuncaoService {

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected fichaService: FichaDespesaService,
    protected exercicioService: ExercicioService,
    protected orgaoService: OrgaoService,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService
  ) { }

  async montarBalanceteDespesa(mes: number, exercicioId: number, orgaos: number[], login: any) {
    const parametros: {} = {};
    if (mes) {
      parametros['mes'] = mes;
    }
    if (exercicioId) {
      parametros['ano'] = exercicioId;
    }
    parametros['orgaos'] = orgaos.join();
    const ex = await this.exercicioService.obterId(exercicioId).toPromise();
    this.fichaService.balancetePorFuncao(parametros)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        Relatorio.imprimirPersonalizado('REFERÊNCIA: ' +
          this.globalService.obterDataBR().monthNames[mes - 1].toLocaleUpperCase() + '/' + ex.ano
          , login.usuario.nome,
          login.orgao.nome, login.brasao,
          this.balanceteDespesaConteudo(dados),
          'landscape', 'Balancete Analítico da Despesa',
          {
            linhas: {
              hLineWidth(i, node) {
                return 1;
              },
              vLineWidth(i) {
                return 1;
              },
              hLineColor(i) {
                return 'black';
              },
              paddingLeft(i) {
                return 3;
              },
              paddingRight(i, node) {
                return 3;
              }
            }
          });
      });
  }

  balanceteDespesaConteudo(dados: any[]): {}[] {
    const registros: {}[] = [
      [{
        text: 'DEMONSTRAÇÃO DA DESPESA POR FUNÇÃO DE GOVERNO',
        colSpan: 14, alignment: 'center', bold: true, fontSize: 11
      },
        '', '', '', '', '', '', '', '', '', '', '', '', ''],
      [
        { text: 'CÓDIGO', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'DESCRIÇÃO', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'ORÇADA', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'MOVIMENTO', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'RECURSOS', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'EMPENHADA', alignment: 'center', colSpan: 2, bold: true, fontSize: 7 },
        { text: '' },
        { text: 'SALDO', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'LIQUIDADO', alignment: 'center', colSpan: 2, bold: true, fontSize: 7 },
        { text: '' },
        { text: 'SALDO', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'PAGAMENTO', alignment: 'center', colSpan: 2, bold: true, fontSize: 7 },
        { text: '' },
        { text: 'DÍVIDA', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 }
      ],
      ['', '', '', '', '',
        { text: 'DO MÊS', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'ACUMULADO', alignment: 'center', bold: true, fontSize: 7 }, '',
        { text: 'DO MÊS', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'ACUMULADO', alignment: 'center', bold: true, fontSize: 7 }, '',
        { text: 'DO MÊS', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'ACUMULADO', alignment: 'center', bold: true, fontSize: 7 }, '']
    ];
    const funcao = {};
    let totalMovimento = 0.00;
    let totalEspecial = 0.00;
    let totalOrcado = 0.00;
    let totalRecurso = 0.00;
    let totalEmpenhadoMes = 0.00;
    let totalEmpenhado = 0.00;
    let totalSaldo = 0.00;
    let totalLiquidadoMes = 0.00;
    let totalLiquidado = 0.00;
    let totalSaldoLiquidado = 0.00;
    let totalPago = 0.00;
    let totalPagoMes = 0.00;
    let totalDivida = 0.00;
    for (const registro of dados) {

      if (!funcao['codigo'] || funcao['codigo'] !== registro['f_codigo']) {
        if (funcao['codigo']) {
          registros.push(this.retornarLinhaSomaFuncao(funcao));
        }
        funcao['codigo'] = registro['f_codigo'];
        funcao['nome'] = registro['f_nome'];
        funcao['orcado'] = 0.00;
        funcao['movimento'] = 0.00;
        funcao['especial'] = 0.00;
        funcao['recurso'] = 0.00;
        funcao['empenhadoMes'] = 0.00;
        funcao['empenhado'] = 0.00;
        funcao['saldo'] = 0.00;
        funcao['liquidado'] = 0.00;
        funcao['liquidadoMes'] = 0.00;
        funcao['saldoLiquidado'] = 0.00;
        funcao['pagoMes'] = 0.00;
        funcao['pago'] = 0.00;
        funcao['divida'] = 0.00;
        registros.push([
          {
            text: this.funcaoService.mascarar('##.##.##', funcao['codigo']) + ' ' + funcao['nome'], colSpan: 13,
            bold: true, fontSize: 7
          },
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ]);
      }
      const movimento: number = registro['movimento'];
      const especial: number = registro['especial'];
      const orcado: number = registro['total_orcado'];
      const saldoRecurso: number = (+movimento + +especial + +orcado);
      const empenhadoMes: number = registro['empenhado_mes'];
      const empenhado: number = registro['empenhado'];
      const saldo = +saldoRecurso - +empenhado;
      const liquidadoMes: number = registro['liquidado_mes'];
      const liquidado: number = registro['liquidado'];
      const saldoLiquidado = +saldo - +liquidado;
      const pagoMes: number = registro['pago_mes'];
      const pago: number = registro['pago'];
      const divida = +empenhado - +pago;
      funcao['orcado'] += +orcado;
      funcao['movimento'] += +movimento;
      funcao['especial'] += +especial;
      funcao['recurso'] += saldoRecurso;
      funcao['empenhadoMes'] += +empenhadoMes;
      funcao['empenhado'] += +empenhado;
      funcao['liquidadoMes'] += +liquidadoMes;
      funcao['liquidado'] += +liquidado;
      funcao['saldoLiquidado'] += +saldo - +liquidado;
      funcao['saldo'] += +saldo;
      funcao['pagoMes'] += +pagoMes;
      funcao['pago'] += +pago;
      funcao['divida'] += +divida;
      totalMovimento += +movimento + +especial;
      totalEspecial += +especial;
      totalOrcado += +orcado;
      totalRecurso += saldoRecurso;
      totalEmpenhadoMes += +empenhadoMes;
      totalEmpenhado += +empenhado;
      totalDivida += +divida;
      totalLiquidadoMes += +liquidadoMes;
      totalLiquidado += +liquidado;
      totalSaldoLiquidado += +saldoLiquidado;
      totalPagoMes += +pagoMes;
      totalPago += +pago;
      totalSaldo += +saldo;

      registros.push([
        { text: registro['sf_codigo'], border: [true, false, true, false], fontSize: 7 },
        {
          text: registro['sf_nome'],
          border: [true, false, true, false], fontSize: 7
        },
        { text: this.funcaoService.convertToBrNumber(orcado), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(movimento), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(saldoRecurso), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(empenhadoMes), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        {
          text: this.funcaoService.convertToBrNumber(empenhado), alignment: 'right',
          border: [true, false, true, false], fontSize: 7
        },
        { text: this.funcaoService.convertToBrNumber(saldo), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(liquidadoMes), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(liquidado), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(saldoLiquidado), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(pagoMes), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(pago), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(divida), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
      ]);
    }
    if (funcao['codigo']) {
      registros.push(this.retornarLinhaSomaFuncao(funcao));
      registros.push([
        {
          text: 'TOTAL GERAL:', colSpan: 2,
          bold: true, fontSize: 7
        },
        '',
        { text: this.funcaoService.convertToBrNumber(totalOrcado), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalMovimento), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalRecurso), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalEmpenhadoMes), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalEmpenhado), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalSaldo), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalLiquidadoMes), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalLiquidado), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalSaldoLiquidado), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalPagoMes), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalPago), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalDivida), bold: true, alignment: 'right', fontSize: 7 },
      ]);
    }
    return [{
      layout: 'linhas',
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        dontBreakRows: true,
        headerRows: 3,
        widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
        body: registros
      }
    }];
  }

  retornarLinhaSomaFuncao(recurso: {}) {
    return [
      {
        text: 'SOMA', colSpan: 2,
        bold: true, fontSize: 7
      },
      '',
      { text: this.funcaoService.convertToBrNumber(recurso['orcado']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(recurso['movimento']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(recurso['recurso']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(recurso['empenhadoMes']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(recurso['empenhado']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(recurso['saldo']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(recurso['liquidadoMes']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(recurso['liquidado']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(recurso['saldoLiquidado']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(recurso['pagoMes']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(recurso['pago']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(recurso['divida']), bold: true, alignment: 'right', fontSize: 7 },
    ];
  }

}
